'use client'

export default function ProvidersErrorFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Context Error</h2>
        <p className="text-gray-600 mb-4">Failed to load application context.</p>
        <button 
          onClick={() => {
            console.log('Manual refresh triggered');
            window.location.reload();
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
} 